import { createTheme } from '@mui/material/styles';

export const Theme = createTheme({
    typography: {
        fontFamily: 'Work Sans',
      },
});